import FormikSelect from "@components/molecules/FormikSelect";
import FormikTime from "@components/molecules/FormikTime";
import MuiTextField from "@components/molecules/MuiTextField";
import { UnitsFields } from "@components/organisms/record/serviceDelivery/units/UnitsField";
import {
  DAY_SELECT_OPTIONS,
  DRIVE_ACTION_CLASS_SELECT_LIST_NUMBER,
  FacilityType,
  TIME_CLASS_LIST
} from "@constants/variables";
import { FormGroup } from "@material-ui/core";
import React from "react";
import { ServiceDeliveryDetailValues } from "@initialize/record/serviceDelivery/initialValues";
import { FormikProps } from "formik";
import { useServiceDeliveryTimeContainer } from "@hooks/record/serviceDelivery/useServiceDeliveryTimeContainer";
import { MAX_PRACTITIONER_DETAILS } from "@constants/mgr/IDOSHIEN/variables";

type Props = {
  formikProps: FormikProps<ServiceDeliveryDetailValues>;
  serviceDeliveryRecordPractitioners1: ServiceDeliveryDetailValues["serviceDeliveryRecordPractitioners1"];
  facilityType: FacilityType;
  setFormikFieldValue: (
    fieldName: string,
    value: number | string | boolean
  ) => void;
};

const ServiceDeliveryOnlyTimeContainer = ({
  formikProps,
  serviceDeliveryRecordPractitioners1,
  facilityType,
  setFormikFieldValue
}: Props): JSX.Element => {
  const fieldName = "serviceDeliveryRecordPractitioners1";
  const detailsFieldName =
    "serviceDeliveryRecordPractitioners1.serviceDeliveryRecordPractitionerDetails";
  const {
    // onChangeDateSelect,
    onChangeInitialTime,
    onChangeActionClass,
    onChangeDetailDateSelect,
    onChangeDetailRecord,
    onDeleteRecord
  } = useServiceDeliveryTimeContainer(
    fieldName,
    detailsFieldName,
    setFormikFieldValue,
    facilityType,
    serviceDeliveryRecordPractitioners1,
    formikProps
  );

  const isPractitionerDetailsLessThan10 =
    serviceDeliveryRecordPractitioners1.serviceDeliveryRecordPractitionerDetails.filter(
      (item) => !item.isDelete
    ).length < MAX_PRACTITIONER_DETAILS;

  return (
    <>
      <FormGroup row>
        <MuiTextField
          value={TIME_CLASS_LIST[0].label}
          label="開始時間"
          disabled
          disabledStyle
          style={{ width: 80 }}
        />
        <FormikTime
          name="serviceDeliveryRecordPractitioners1.startTime"
          label=""
          placeholder="00:00"
          size="smallMedium"
          maxLength={5}
          onChangeHookTime={onChangeInitialTime}
          style={{ marginTop: 16, marginRight: 24 }}
        />
        <FormikSelect
          name="serviceDeliveryRecordPractitioners1.endTimeDate"
          label="終了時間"
          options={DAY_SELECT_OPTIONS}
          style={{ width: 80 }}
          // onChangeHook={(e) => onChangeDateSelect(e)}
        />
        <FormikTime
          name="serviceDeliveryRecordPractitioners1.endTime"
          placeholder="00:00"
          size="smallMedium"
          maxLength={5}
          onChangeHookTime={onChangeInitialTime}
          style={{ marginTop: 16, marginRight: 24 }}
        />
      </FormGroup>
      <div>
        <UnitsFields
          formikProps={formikProps}
          unitKey="serviceDeliveryRecordPractitioners1"
          onDeleteRecord={onDeleteRecord}
          onChangeTime={onChangeDetailRecord}
          onChangeSelect={onChangeDetailDateSelect}
          onChangeActionClass={onChangeActionClass}
          setFormikFieldValue={formikProps.setFieldValue}
          isAddButton={isPractitionerDetailsLessThan10}
          list={
            serviceDeliveryRecordPractitioners1.serviceDeliveryRecordPractitionerDetails
          }
          practitionerNum={serviceDeliveryRecordPractitioners1.practitionerNum}
          practitionerValues={serviceDeliveryRecordPractitioners1}
          actionClassLabel={DRIVE_ACTION_CLASS_SELECT_LIST_NUMBER[0].label}
          actionClassOptions={DRIVE_ACTION_CLASS_SELECT_LIST_NUMBER}
          facilityType={facilityType}
        />
      </div>
    </>
  );
};

export default ServiceDeliveryOnlyTimeContainer;
